export default [
    {
        path: '/product/list/:filter?',
        name: 'product_list',
        component: () => import('@src/product/product-list.vue'),
        meta: {
            title: 'Alle Produkte',
            // role: 'ROLE_...',
        },
    },
];
